import { useState } from 'react';
import { useBuildingListQuery } from '@common/cache';
import { useDrawerStore } from 'store/drawer.store.ts';
import { IBuildingTableEntry } from '../types';
import { useBuildingTableStore } from '../Filters/filters.store';

export const useBuilding = () => {
  const { filters, appliedFiltersCount } = useBuildingTableStore();
  const [isCreateBuildingModalOpen, setIsCreateBuildingModalOpen] =
    useState(false);
  const [isImportBuildingModalOpen, setIsImportBuildingModalOpen] =
    useState(false);
  const [selectedBuildingId, setSelectedBuildingId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = {
      count: 0,
      records: [],
    },
    isRefetching,
    isFetching,
  } = useBuildingListQuery(filters);

  const entries: IBuildingTableEntry[] = data.records;

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedBuildingId('');
  };

  const handleOpenBuildingDetails = (id: string) => {
    setSelectedBuildingId(id);
    setDrawerOpen(true);
  };

  const handleOpenCreateBuildingModal = () => {
    setIsCreateBuildingModalOpen(true);
  };

  const handleCloseCreateBuildingModal = () => {
    setIsCreateBuildingModalOpen(false);
  };

  const handleOpenImportBuildingModal = () => {
    setIsImportBuildingModalOpen(true);
  };

  const handleCloseImportBuildingModal = () => {
    setIsImportBuildingModalOpen(false);
  };

  return {
    entries,
    totalCount: data.count,
    isInitialFilters: appliedFiltersCount === 0 && !filters.search,
    isLoading: isRefetching || isFetching,
    selectedBuildingId,
    handleCloseDrawer,
    handleOpenBuildingDetails,
    isCreateBuildingModalOpen,
    handleOpenCreateBuildingModal,
    handleCloseCreateBuildingModal,
    isImportBuildingModalOpen,
    handleOpenImportBuildingModal,
    handleCloseImportBuildingModal,
    isDrawerOpen,
  };
};
